"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var GlobalEvent;

(function (GlobalEvent) {
  GlobalEvent["PORTFOLIO_OPTIMIZED"] = "PORTFOLIO_OPTIMIZED";
  GlobalEvent["ENTITY_EXPLORER_ENTITY_SELECTION"] = "ENTITY_EXPLORER_ENTITY_SELECTION";
})(GlobalEvent = exports.GlobalEvent || (exports.GlobalEvent = {}));